export let Gender;

(function (Gender) {
  Gender["NotSelected"] = "";
  Gender["Female"] = "F";
  Gender["Male"] = "M";
  Gender["Other"] = "O";
})(Gender || (Gender = {}));

export let HateEntryType;

(function (HateEntryType) {
  HateEntryType[HateEntryType["Member"] = 30] = "Member";
  HateEntryType[HateEntryType["Brand"] = 40] = "Brand";
})(HateEntryType || (HateEntryType = {}));

export let UserAccountStatus;

(function (UserAccountStatus) {
  UserAccountStatus[UserAccountStatus["Active"] = 0] = "Active";
  UserAccountStatus[UserAccountStatus["Deleted"] = 3] = "Deleted";
  UserAccountStatus[UserAccountStatus["Banned"] = 8] = "Banned";
  UserAccountStatus[UserAccountStatus["ActiveUnconfirmed"] = 9] = "ActiveUnconfirmed";
  UserAccountStatus[UserAccountStatus["TemporaryUnconfirmed"] = 14] = "TemporaryUnconfirmed";
})(UserAccountStatus || (UserAccountStatus = {}));

export let UserPrivacyPermission;

(function (UserPrivacyPermission) {
  UserPrivacyPermission[UserPrivacyPermission["Everyone"] = 0] = "Everyone";
  UserPrivacyPermission[UserPrivacyPermission["Members"] = 1] = "Members";
  UserPrivacyPermission[UserPrivacyPermission["Nobody"] = 2] = "Nobody";
})(UserPrivacyPermission || (UserPrivacyPermission = {}));